<template>
  <div
    class="SurchargeNotice w-full relative z-[1001] border-t border-border-subtle"
    :class="{ 'bg-bg-warning': isImpersonating }"
    :style="!isImpersonating ? { backgroundColor: globalContent.siteNotice?.siteUspBackgroundColor?.color } : undefined"
  >
    <div class="layout-container flex items-center justify-center py-8 desk:py-12">
      <div
        class="flex items-center gap-8 type-sm desk:type-xs"
        :class="isImpersonating ? 'text-text-warning' : (globalContent.siteNotice?.siteUspTextColor ? 'text-lightest' : 'text-darkest')"
      >
        <GlobalIcon name="info" size="xsmall" />
        <span>
          {{ $t('surcharge.banner.text', { link: '' }) }}
          <nuxt-link
            v-if="hasLink"
            :to="$manualUrl($t('surcharge.banner.linkUrl'))"
            class="underline hover:no-underline"
          >
            {{ $t('surcharge.banner.linkText') }}
          </nuxt-link>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useGlobalContentStore } from '~/store/globalContent';
import { useUserStore } from '~/store/user';

const globalContent = useGlobalContentStore();
const userStore = useUserStore();
const { $t } = useNuxtApp();

const isImpersonating = computed(() => !!userStore.userProfile?.impersonatingCompany);

const hasLink = computed(() => {
  const linkUrl = $t('surcharge.banner.linkUrl');
  return linkUrl && linkUrl !== 'surcharge.banner.linkUrl' && linkUrl.trim().length > 0;
});
</script>
